import { gql, useMutation } from '@apollo/client'
import { BodyText, Heading, Modal } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import { useEffect } from 'react'

import { useValidateOabModalContext } from '../../context'
import { useHandleValidationErrors } from '../../hooks'
import validatingSvg from '../../images/oab-verificando.svg'
import styles from '../steps.module.scss'
import {
  ValidateOabMutationMutation,
  ValidateOabMutationMutationVariables,
} from './__generated__/validating.graphql'

export const ValidateOabMutation = gql`
  mutation ValidateOabMutation($input: ValidateOabInput!) {
    validateOab(input: $input) {
      profile {
        isOabValid
      }
    }
  }
`

export function Validating() {
  const { getServerDataValues } = useValidateOabModalContext()
  const [validateOab, { data, error }] = useMutation<
    ValidateOabMutationMutation,
    ValidateOabMutationMutationVariables
  >(ValidateOabMutation)

  useEffect(() => {
    const { oab, oabUf, oabType, cpf, birthDate, origin } = getServerDataValues()
    validateOab({
      variables: {
        input: {
          oab,
          oabUf,
          oabType,
          cpf,
          birthDate,
          saveDetails: false,
          throwErrorWhenIsInvalid: true,
          checkDuplicatedValidatedOabOnly: true,
          origin,
        },
      },
      // Catch the error to avoid unhandled promise rejection, error is handled in the useHandleValidationErrors below
    }).catch(() => undefined)
  }, [validateOab, getServerDataValues])

  useHandleValidationErrors({ isOabValid: data?.validateOab?.profile?.isOabValid, error })

  return (
    <Modal.Body className={styles.infoModalBody}>
      <Image src={validatingSvg} width={140} height={140} loading="lazy" alt="" />
      <Heading className={styles['infoModalBody-heading']}>Verificando OAB...</Heading>
      <BodyText className={styles['infoModalBody-bodyText']}>
        Aguarde enquanto validamos as informações.
      </BodyText>
    </Modal.Body>
  )
}
